import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { PostsFilter } from "./PostsFilter";
import { PostsList } from "./PostsList";
import { CreatePostDialog } from "./CreatePostDialog";
import { EditPostDialog } from "./EditPostDialog";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

export const Posts: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tab, id: postId } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string };

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleCloseCreateDialog = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
  };

  const handleCloseEditDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <PostsFilter onCreatePost={handleCreate} />
        <PostsList onEditPost={handleEdit} />
      </Stack>

      <CreatePostDialog
        open={tab === "create"}
        onClose={handleCloseCreateDialog}
        onCompleted={handleCloseCreateDialog}
      />

      <EditPostDialog
        open={tab === "edit"}
        postId={postId ?? null}
        onClose={handleCloseEditDialog}
        onCompleted={handleCloseEditDialog}
      />
    </FilterProvider>
  );
};
